export default "__VITE_ASSET__DbcwJCOx__"